import isReed from './is-reed'

function isSalaryVisible(companyName: string, source: string, isSalaryEstimated: boolean): boolean {
  return companyName !== 'Duke Health' && !(isReed(source) && isSalaryEstimated)
}

export default isSalaryVisible
